import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { classNames, FlexColumn } from "@opensea/ui-kit";
import { NarrativeText } from "../NarrativeText";
import { TextOnlyFragment } from "./TextOnly.fragment";
export function TextOnly(t0) {
  const $ = _c(15);
  const {
    className,
    module: moduleKey,
    textClassName,
    textContainerClassName
  } = t0;
  let t1;
  if ($[0] !== moduleKey) {
    t1 = readFragment(TextOnlyFragment, moduleKey);
    $[0] = moduleKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const moduleData = t1;
  let t2;
  if ($[2] !== className) {
    t2 = classNames("max-h-[800px] flex-1 select-text overflow-auto", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = moduleData.horizontalTextPosition;
  const t4 = moduleData.variant;
  const t5 = moduleData.verticalTextPosition;
  let t6;
  if ($[4] !== moduleData.description || $[5] !== moduleData.title || $[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== textClassName || $[10] !== textContainerClassName) {
    t6 = <NarrativeText className={textClassName} description={moduleData.description} horizontalTextPosition={t3} textContainerClassName={textContainerClassName} title={moduleData.title} variant={t4} verticalTextPosition={t5} />;
    $[4] = moduleData.description;
    $[5] = moduleData.title;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = textClassName;
    $[10] = textContainerClassName;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t6) {
    t7 = <FlexColumn className={t2}>{t6}</FlexColumn>;
    $[12] = t2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}